import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AccessProfile } from 'src/app/component/page/company/access-profile/models/access-profile';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'canAccess'
})
export class CanAccessPipe implements PipeTransform {

  transform(profile: AccessProfile, rule: string | string[], verifyOnlyModule = false): boolean {
    if (!profile || !rule) {
      return true; // by default, allow the access
    }

    if (Array.isArray(rule)) {
      let rulesCounter = rule.length;

      for (let singleRule of rule) {
        const profilRuleModule = profile.modules.find(m => m.name === singleRule);

        if(!profilRuleModule){
          rulesCounter--;
          continue;
        }
      }

      if (rulesCounter > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      const profilRuleModule = profile.modules.find(m => m.name === rule.split('.').shift());

      if(!profilRuleModule){
        return false;
      }

      if (verifyOnlyModule && profilRuleModule) {
        return true; // can access the requested module
      }

      return profilRuleModule.tabs && profilRuleModule.tabs.some(t => t === rule); // can access the requested inner rule into module
    }
  }

  // ["OS.datails.seeValues", "OS.details.tabs.algumacoisa"]
}
